<template>
  <div class="card col-md-4">
    <div class="card__wrapper" ref="cardWrapper">
      <div class="card__featured">
        <router-link v-if="url" :to="url" />
        <img v-if="featured" :src="featured" :alt="featuredAlt" />
      </div>
      <div class="card__info">
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Card",
  props: {
    featured: {
      type: String,
      default: require("@/assets/media/backgrounds/default.jpg")
    },
    featuredAlt: {
      type: String,
      default: "Featured"
    },
    url: {
      type: String,
      default: "/"
    }
  }
};
</script>

<style lang="scss" scoped>
.card {
  margin-bottom: 60px;
  .card__wrapper {
    border-radius: 10px;
    overflow: hidden;
    box-shadow: 0px 3px 10px 1px rgba(0, 0, 0, 0.16);
    height: 100%;
    @media (max-width: 767px) {
      /* Add important here to override dynamic inline style */
      height: auto !important;
    }
  }
  .card__info {
    background-color: $white;
    padding: 15px 35px;
  }
  .card__featured {
    position: relative;
    img {
      display: block;
      margin-bottom: 15px;
      max-width: 100%;
      width: 100%;
      height: 250px;
      object-fit: cover;
      object-position: center;
    }
    a {
      height: 100%;
      width: 100%;
      position: absolute;
    }
  }
  .card__subtitle {
    color: $gray-500;
    font-size: 15px;
    line-height: 26px;
    margin-bottom: 5px;
  }
  .card__title {
    color: $gray-900;
    font-size: 20px;
    font-weight: 500;
    line-height: 26px;
    margin-bottom: 10px;
  }
  .card__excerpt {
    color: $gray-500;
    margin-bottom: 15px;
  }
  .card__cta {
    color: $brand-primary;
    display: block;
    font-size: 15px;
  }
}
</style>
